<template>
  <div class="panel-other">
    <div class="title">投放数据</div>
    <div class="condition">
      <div class="condition__info">
        <span class="condition__info__label"> 方案名称 </span>
        <el-select v-model="projectName" clearable placeholder="请选择方案名称">
          <el-option
            v-for="(option, index) in projectNames"
            :key="index"
            :label="option.solutionName"
            :value="option.solutionId"
          >
          </el-option>
        </el-select>
      </div>
      <div class="condition__info">
        <span class="condition__info__label"> 投放时间 </span>
        <el-date-picker
          v-model="time"
          type="datetimerange"
          range-separator="至"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
        >
        </el-date-picker>
      </div>
      <div class="condition__info">
        <span class="condition__info__label"> 行业 </span>
        <el-select v-model="industry" clearable placeholder="请选择行业">
          <el-option
            v-for="(option, index) in industryList"
            :key="index"
            :label="option[Object.keys(option)[0]]"
            :value="Object.keys(option)[0]"
          >
          </el-option>
        </el-select>
      </div>
      <div class="condition__info">
        <span class="condition__info__label"> 状态 </span>
        <el-select v-model="status" clearable placeholder="请选择状态">
          <el-option
            v-for="(option, index) in statusList"
            :key="index"
            :label="option.value"
            :value="option.key"
          >
          </el-option>
        </el-select>
      </div>
      <el-button class="search" type="primary" @click="getRecordList(1)"
        >搜索</el-button
      >
    </div>
    <div class="body">
      <div class="handle">
        <span @click="importExcel">导出</span>
        <el-popover
          placement="bottom"
          popper-class="importPopper"
          trigger="manual"
          :visible="isShowTreePopover"
        >
          <div>
            <el-tree
              :data="columnData"
              node-key="id"
              :props="defaultProps"
              show-checkbox
              @check="check"
              ref="tree"
            >
            </el-tree>
            <section class="trueHandle">
              <el-button type="primary" @click="changeColumn()">保存</el-button>
              <el-button @click="isShowTreePopover = false">取消</el-button>
            </section>
          </div>
          <template v-slot:reference>
            <el-button @click="isShowTreePopover = true">自定义列</el-button>
          </template>
        </el-popover>
      </div>
      <el-tabs v-model="activeName">
        <el-tab-pane label="百度营销通" name="BaiduMarketing">
          <el-table
            :data="projectData"
            :border="false"
            :header-cell-style="{ background: '#EFF1F4' }"
            :fit="true"
            style="width: 100%"
          >
            <el-table-column
              align="left"
              label="方案名称"
              :width="firstWidth[0]"
            >
              <template #default="scope">
                <span
                  >{{ scope.row.solutionName ? scope.row.solutionName : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="时间" :width="firstWidth[1]">
              <template #default="scope">
                <span
                  >{{ scope.row.commitTime ? scope.row.commitTime : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="姓名" :width="firstWidth[2]">
              <template #default="scope">
                <span>{{ scope.row.name ? scope.row.name : "-" }} </span>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="联系方式"
              :width="firstWidth[3]"
            >
              <template #default="scope">
                <span>{{ scope.row.phone ? scope.row.phone : "-" }} </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="行业" :width="firstWidth[4]">
              <template #default="scope">
                <span
                  >{{ scope.row.industry ? scope.row.industry : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="地域" :width="firstWidth[5]">
              <template #default="scope">
                <span>{{ scope.row.area ? scope.row.area : "-" }} </span>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              label="投放计划"
              :width="firstWidth[6]"
            >
              <template #default="scope">
                <span
                  >{{ scope.row.planName ? scope.row.planName : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column align="left" label="搜索词" :width="firstWidth[7]">
              <template #default="scope">
                <span
                  >{{ scope.row.searchWord ? scope.row.searchWord : "-" }}
                </span>
              </template>
            </el-table-column>
            <el-table-column
              align="left"
              :label="column.value"
              v-for="(column, index) in otherColumn"
              :key="index"
              :width="otherWidth[index]"
            >
              <template #default="scope">
                <span>{{ JSON.parse(scope.row.detail)[column.key] }} </span>
              </template>
            </el-table-column>
            <el-table-column align="right" label="状态" :width="130">
              <template #default="scope">
                <el-popover
                  placement="bottom"
                  trigger="manual"
                  :visible="isShowPopover + '' == scope.$index + ''"
                  width="400"
                >
                  <div class="popoverWrap">
                    <section>
                      <span>状态：</span>
                      <el-select v-model="chooseStatus" placeholder="请选择">
                        <el-option
                          v-for="item in statusList"
                          :key="item.value"
                          :label="item.value"
                          :value="item.key"
                        >
                        </el-option>
                      </el-select>
                    </section>
                    <section>
                      <el-button
                        type="primary"
                        @click="updateStatus(scope.row.clueId)"
                        >保存</el-button
                      >
                      <el-button @click="isShowPopover = ''">取消</el-button>
                    </section>
                  </div>
                  <template v-slot:reference>
                    <span
                      type="text"
                      class="handleSpan"
                      @click="onShow(scope.$index, scope.row.status)"
                    >
                      {{
                        statusList[scope.row.status]
                          ? statusList[scope.row.status]["value"]
                          : ""
                      }}
                      <i class="icon iconfont icon-icon_editor"></i>
                    </span>
                  </template>
                </el-popover>
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            class="pagination"
            @current-change="getRecordList"
            :page-size="projectPageSize"
            :total="projectTotal"
            layout="total, ->, prev,pager, next"
          >
          </el-pagination>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import dayjs from 'dayjs'
import _ from 'lodash'
import { getBdYxtClueRecordDtos, getBdYxtMessageDto, updateBdYxtClueRecordStatus, downLoadClueExcel } from '../../API/thirdPlatform'
export default {
  data () {
    return {
      firstWidth: [],
      isShowTreePopover: false,
      defaultProps: {
        children: 'children',
        label: 'label'
      },
      otherColumn: [],
      defKeys: [2, 3, 4, 5, 6, 1, 16, 20],
      projectName: '',
      projectNames: [],
      time: '',
      columnData: [],
      industry: '',
      activeName: 'BaiduMarketing',
      industryList: [],
      projectPageSize: 8,
      projectTotal: 1,
      chooseStatus: '',
      isShowPopover: '',
      projectData: [],
      chooseKey: [],
      allKey: [],
      otherWidth: [],
      projectPageNumber: 0,
      status: '',
      statusList: []
    }
  },
  methods: {
    adjustColumnWidth (table) {
      this.otherWidth = []
      this.firstWidth = []
      var maxArr = []
      var tableWidth = document.querySelector('.panel-other .el-tabs').scrollWidth
      const colgroup = table.querySelector('colgroup')
      const colDefs = [...colgroup.querySelectorAll('col')]
      colDefs.forEach((col, index) => {
        const clsName = col.getAttribute('name')
        const cells = [
          ...document.querySelectorAll(`td.${clsName}`)
        ]
        const widthList = cells.map((el) => {
          return el.querySelector('.cell') ? el.querySelector('.cell').scrollWidth : 0
        })
        const max = Math.max(...widthList)
        const padding = 32
        maxArr.push((max + padding > 80) ? (max + padding) : 80)
      })
      maxArr.splice(maxArr.length - 2, 2)
      var totalWidth = maxArr.reduce(function (prev, curr, idx, arr) {
        return prev + curr
      })
      if (tableWidth > totalWidth) {
        var width = (tableWidth - totalWidth - 130) / maxArr.length
        maxArr = maxArr.map((item, index) => item + width)
      }
      colDefs.forEach((col, index) => {
        if (index <= 7 || index === colDefs.length - 1) {
          this.firstWidth.push(maxArr[index])
        } else {
          this.otherWidth.push(maxArr[index])
        }
      })
    },
    async importExcel () {
      var data = {
        fieldList: 'solutionName,commitTime,area,industry,name,phone,planName,searchWord'
      }
      if (this.otherColumn.length > 0) {
        data.fieldList = data.fieldList + ',' + _.join(this.otherColumn.map(item => item.key), ',')
      }
      if (this.projectName !== '') {
        data.solutionId = this.projectName
      }
      if (this.industry !== '') {
        data.industry = this.industry
      }
      if (this.status !== '') {
        data.status = this.status
      }
      if (this.time !== '') {
        data.startTime = dayjs(this.time[0]).format('YYYY/MM/DD HH:mm:ss')
        data.endTime = dayjs(this.time[1]).format('YYYY/MM/DD HH:mm:ss')
      }
      const formData = new FormData()
      _.map(data, (value, key) => {
        formData.append(key, value)
      })
      var res = await downLoadClueExcel(formData)
      const blob = new Blob([res], {
        type: 'application/vnd.ms-excel,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'
      })
      const downloadElement = document.createElement('a')
      const href = window.URL.createObjectURL(blob)
      downloadElement.style.display = 'none'
      downloadElement.href = href
      downloadElement.download = decodeURI('百度营销通投放数据') // 下载后文件名
      document.body.appendChild(downloadElement)
      downloadElement.click() // 点击下载
      document.body.removeChild(downloadElement) // 下载完成移除元素
      window.URL.revokeObjectURL(href) // 释放掉blob对象
    },
    changeColumn () {
      this.otherColumn.splice(0, this.otherColumn.length)
      this.chooseKey.forEach(item => {
        var index = this.allKey.findIndex((i, index) => i.id === item)
        if (index !== -1) {
          this.otherColumn.push(this.allKey[index])
        }
      })
      this.isShowTreePopover = false
      this.$nextTick(() => {
        this.adjustColumnWidth(document.querySelector('.el-table'))
      })
    },
    check (target, tree) {
      this.chooseKey = tree.checkedKeys
    },
    async updateStatus (id) {
      var submitData = {
        clueId: id,
        status: this.chooseStatus
      }
      const formData = new FormData()
      _.map(submitData, (value, key) => {
        formData.append(key, value)
      })
      await updateBdYxtClueRecordStatus(formData)
      this.isShowPopover = ''
      this.$message({
        message: '状态修改成功',
        type: 'success'
      })
      await this.getRecordList(this.projectPageNumber)
    },
    onShow (index, status) {
      this.isShowPopover = index
      this.chooseStatus = this.statusList[status] ? this.statusList[status].value : ''
    },
    async getRecordList (projectPageNumber) {
      this.projectPageNumber = projectPageNumber
      var data = {
        pageNum: projectPageNumber,
        pageSize: this.projectPageSize
      }
      if (this.projectName !== '') {
        data.solutionId = this.projectName
      }
      if (this.industry !== '') {
        data.industry = this.industry
      }
      if (this.status !== '') {
        data.status = this.status
      }
      if (this.time !== '') {
        data.startTime = dayjs(this.time[0]).format('YYYY/MM/DD HH:mm:ss')
        data.endTime = dayjs(this.time[1]).format('YYYY/MM/DD HH:mm:ss')
      }
      const res = await getBdYxtClueRecordDtos(data)
      this.projectTotal = res.total
      this.projectData = res.list
      this.$nextTick(() => {
        this.adjustColumnWidth(document.querySelector('.el-table'))
      })
    },
    async getSearchKeywordList () {
      const res = await getBdYxtMessageDto()
      this.projectNames = res.solutionNameList
      this.industryList = res.industryList
      const statusList = res.statusList
      statusList.forEach(item => {
        this.statusList.push({
          key: Object.keys(item)[0],
          value: item[Object.keys(item)[0]]
        })
      })
      const formDataList = res.formDataList
      var count = 0
      formDataList.forEach((item, index) => {
        var obj = {
          id: count,
          label: item.label,
          children: []
        }
        count++
        item.children.forEach((child, childIndex) => {
          var childKey = ''
          Object.keys(child).forEach(key => {
            if (key !== 'choosed') {
              childKey = key
            }
          })
          var childItem = {
            id: count,
            label: child[childKey],
            disabled: false
          }
          if (this.defKeys.indexOf(count) !== -1) {
            childItem.disabled = true
          } else {
            this.allKey.push({
              id: count,
              key: childKey,
              value: child[childKey]
            })
          }
          // if (child.choosed && this.defKeys.indexOf(count) === -1) {
          //   this.defKeys.push(count)
          // }
          obj.children.push(childItem)
          count++
        })
        this.columnData.push(obj)
      })
      this.$nextTick(() => {
        this.$refs.tree.setCheckedKeys(this.defKeys)
      })
    }
  },
  created () {
    this.getRecordList()
    this.getSearchKeywordList()
  }
}
</script>
<style lang="less">
.el-popover {
  width: 223px;
  background: #ffffff;
  border: 1px solid #cfd1d5;
  box-sizing: border-box;
  border-radius: 4px;
}

.importPopper {
  width: 175px !important;
}
.panel-other {
  .el-tabs__content {
    overflow: auto !important;
  }
  .el-table .cell {
    height: 33px;
    line-height: 33px;
    white-space: nowrap !important;
    overflow: auto !important;
    overflow-y: hidden !important;
    display: inline-block;
  }
  .el-table td:last-child .cell {
    overflow: hidden !important;
  }
}
</style>
<style lang="less" scoped>
.handleSpan {
  cursor: pointer;
  color: #2878ff;
}
.trueHandle {
  display: flex;
  margin-top: 19px;
  .el-button {
    display: flex;
    align-items: center;
  }
}
.popoverWrap {
  section {
    margin-top: 5px;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      font-family: PingFang SC;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      line-height: 24px;
      color: #111a2e;
    }
    .el-select {
      width: 123px;
    }
    .el-button {
      display: flex;
      align-items: center;
    }
  }
  section:last-child {
    margin-top: 20px;
  }
}
.panel-other {
  .el-button {
    display: flex;
    align-items: center;
  }
  .body {
    position: relative;
    padding: 20px;
    background-color: var(--white);
    .handle {
      position: absolute;
      display: flex;
      right: 20px;
      z-index: 100;
      height: 40px;
      cursor: pointer;
      top: 20px;
      font-family: PingFangSC-Regular, sans-serif;
      font-style: normal;
      font-weight: normal;
      font-size: 14px;
      span {
        display: inline-block;
        width: 72px;
        height: 32px;
        text-align: center;
        line-height: 32px;
        border-radius: 4px;
      }
      span:first-child {
        margin-left: 45px;
        background: #1dd3a4;
        margin-right: 8px;
        color: white;
      }
      .el-button {
        color: #404757;
      }
    }
  }
  .title {
    font-size: 20px;
    color: var(--main-text);
    margin-bottom: 20px;
  }
  .condition {
    background-color: var(--white);
    border-radius: 1px;
    padding: 14px 20px;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    margin-bottom: 12px;
    &__info {
      display: flex;
      align-items: center;
      margin-right: 20px;
      &__label {
        color: var(--main-text);
        font-size: 14px;
        margin-right: 12px;
      }
      &__data {
        width: 280px;
      }
    }
  }
}
</style>
